import { jwtDecode } from 'jwt-decode'

/**
 * Information about the current token.
 */
export interface TokenInfo {
  /**
   * The serialized JWT.
   */
  readonly token: string

  /**
   * The token issuer.
   */
  readonly issuer: string

  /**
   * ID of the user in the auth system.
   */
  readonly authId: string

  /**
   * Whether MFA is enabled with the auth provider.
   */
  readonly mfaEnabled: boolean

  /**
   * The time at which the token expires.
   */
  readonly expiresAt: Date
}

/**
 * Decodes an encoded JWT.
 *
 * @param jwt
 */
export function decodeTokenInfo(jwt: string): TokenInfo {
  const decoded = jwtDecode<DecodedToken>(jwt)
  return {
    token: jwt,
    issuer: decoded.iss,
    authId: decoded.sub,
    expiresAt: new Date(decoded.exp * 1000),
    mfaEnabled: Boolean(decoded['https://worklayer.com/claims.mfa_enrolled']),
  }
}

/**
 * A JWT that has been decoded.
 */
interface DecodedToken {
  sub: string
  iss: string
  exp: number
  'https://worklayer.com/claims.mfa_enrolled'?: string
}
